import { HEADER_ONBOARDING_CONGRATULATIONS_VIEW } from '../actions/types';

export const headerOnboardingCongratulationsGaActionEvents = {
  [HEADER_ONBOARDING_CONGRATULATIONS_VIEW]: ({ pageName }) => ({
    category: 'Onboarding',
    action: 'Congratulations banner view',
    label: pageName,
  }),
};
